"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoTransactionMonitoringDescription = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.NoTransactionMonitoringDescription = {
    priority: 3,
    label: 'fields.payload.mor_group_answers.no_transaction_monitoring_description.label',
    fallbackLabel: 'Please explain how the risks associated with transaction monitoring for detecting money laundering, terrorism financing, and other illegal activities are managed, and whether you have any alternative processes in place to address these risks.',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.has_transaction_monitoring', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.has_transaction_monitoring === false
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.has_transaction_monitoring === false
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
